import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

function BlankPage(props) {
  return (
    <>
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>Select any page to continue</CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default BlankPage;
